export default __webpack_public_path__ + "static/media/Ocean_Floor.bc147152.svg";